import customLoadStoolItems from "@iewcasia/Store/Handlers/Custom/CustomLoadStoolItems";
import { setGA4Event } from "@iewcasia/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter, makeHandlerChainAwaitable, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import {
    AddCartLinesApiParameter,
    addLineCollection,
    AddProductApiParameter,
} from "@insite/client-framework/Services/CartService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    PopulateApiParameter,
    SendDataToApi,
} from "@insite/client-framework/Store/Data/Carts/Handlers/AddCartLines";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

replaceInChain(chain, PopulateApiParameter, async props => {
    const cartLineCollection: CartLineModel[] = [];
    const state = props.getState();
    const cartLines = getCurrentCartState(state).value?.cartLines;
    let showStoolModal = false;

    // Verndale Customization
    const pageType = getCurrentPage(props.getState()).type;
    let itemsWithStools: AddProductApiParameter[] = [];
    const itemsWithStool = makeHandlerChainAwaitable<
        Parameters<typeof customLoadStoolItems>[0],
        AddProductApiParameter[]
    >(customLoadStoolItems);

    props.parameter.productInfos.forEach(o => {
        cartLineCollection.push({
            productId: o.productId,
            qtyOrdered: o.qtyOrdered,
            unitOfMeasure: o.unitOfMeasure,
        } as CartLineModel);
    });

    // Verndale Customization
    if (pageType === "QuickOrderPage") {
        itemsWithStools = await itemsWithStool({
            items: props.parameter.productInfos,
        })(props.dispatch, props.getState);
    }
    // End Verndale Customization

    const updatedCartLinesCollection = cartLineCollection
        .map(line => {
            const parsedQty = line.qtyOrdered ? parseFloat(line.qtyOrdered.toString()) : 1;
            line.qtyOrdered = parsedQty > 0 ? parsedQty : 1;

            // Verndale Customization
            if (itemsWithStools.length > 0) {
                const reorderItemHasStool = itemsWithStools.find(item => item.productId === line.productId);
                const itemAlreadyInCart = cartLines?.some(cartLine => cartLine.productId === line.productId);

                if (reorderItemHasStool) {
                    if (!itemAlreadyInCart) {
                        line.properties = {
                            spoolSelected: "1",
                            spoolLength: `${Math.max(line.qtyOrdered || 1, 1)}`, // Ensures qtyOrdered is at least 1
                        };
                    } else {
                        // If the item is already in the cart, we don't add it to the cartlines
                        showStoolModal = true;
                        return null;
                    }
                }
            }

            return line;

            // End Verndale Customization
        })
        .filter(line => line);

    props.apiParameter = {
        cartLineCollection: {
            cartLines: updatedCartLinesCollection,
        },
        cartId: API_URL_CURRENT_FRAGMENT,
    } as AddCartLinesApiParameter;

    if (itemsWithStools && itemsWithStools.length > 0 && showStoolModal) {
        props.dispatch({
            type: "Custom/SetSpoolModal/CompleteSetIsOpen",
            isOpen: true,
        } as any);
    }
});

replaceInChain(chain, SendDataToApi, async props => {
    // // Verndale Customization
    const cartLines = props.apiParameter.cartLineCollection.cartLines;
    if (!cartLines || !cartLines.length) {
        return;
    }
      
    setGA4Event(cartLines, "add_to_cart");
    // End Verndale Customization
    props.apiResult = await addLineCollection(props.apiParameter);  
});

